import {
    IProps,
} from './types';

import React, {
    FC,
    useEffect,
} from 'react';

import {
    useInputMask,
} from 'tools/hooks';

import StringInput from '../StringInput';

import {
    MASK,
} from './constants';
import {
    checkValue,
    formatValue,
} from './functions';

const TimeInput: FC<IProps> = (props) => {
    const {value, setValue, inputProps} = useInputMask({
        value: props.value ?? '',
        mask: MASK,
        shouldChange(value: string): boolean {
            return checkValue(value);
        },
        onChange(value: string) {
            const formattedValue = formatValue(value);

            props.onChangeValue?.(formattedValue);
        },
    });

    useEffect(() => {
        setValue(props.value ?? '');
    }, [props.value]);

    return (
        <StringInput
            className={props.className}
            size={props.size}
            label={props.label}
            placeholder={props.placeholder}
            value={value}
            isError={props.isError}
            errorMessage={props.errorMessage}
            isDisabled={props.isDisabled}
            {...inputProps}
        />
    );
};

export default TimeInput;
